import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({
  data: {
    plan: 0
  },
  loading: true
});

export const { getMarketingStatus, setLoading } = createActions({
  getMarketingStatus: result => {
    return result;
  },
  setLoading: result => result
});

const marketingStatus = handleActions(
  {
    [getMarketingStatus]: (state, action) => {
      return state.set('data', action.payload);
    },
    [setLoading]: (state, action) => {
      return state.set('loading', action.payload);
    }
  },
  initState
);

export default marketingStatus;
